import React, { useEffect, useState } from 'react';
import { VersionesGiasAdapter } from '../../../../../infraestructure/persistence/rest/VersionesGiasAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorVersionesGias from './selector';

export const SelectorVersionesGiasContainer = (props: any) => {
  
	const api = new VersionesGiasAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [versiones, setVersiones] = useState<any>([])
	let [versionAño, setVersionAño] = useState<any>(props.valueOfSelected)
	let result: any;
  
  useEffect(()=>{
    if(props.valueOfSelected === undefined && props.ejercicio){
		getVersionGiasAño(props.ejercicio)
	}
	getVersionesGias(true);
  },[])


	const getVersionesGias = async (soloPrincipales?: boolean) => {
		try {
			result = await api.ListarVersionesGias(soloPrincipales);
			if(result.data && result.data!=="")
			{
				setVersiones([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  const getVersionGiasAño = async (año: number) => {
	try {
		result = await api.VersionGias(año);
		if(result.data && result.data!=="")
		{
			setVersionAño((result.data[0]&&result.data[0].idVersion) || undefined);
		}else{resultError()}
	} catch (error) {
		let exception = ServerErrorMessage(error);
		exceptionError(exception)
	}
};

  return <SelectorVersionesGias {...props} data={versiones} idVersion={versionAño}/>
};

export default SelectorVersionesGiasContainer;